import { ALL_BRANCHES } from './fis-report.const';

export function isAllBranches(selection: readonly string[]): boolean {
  return selection.includes(ALL_BRANCHES);
}

/**
 * "Alle" and single branches exclude each other in the multiselect: the
 * latest pick wins, so choosing "Alle" clears the branches and choosing a
 * branch drops "Alle".
 */
export function normalizeBranchSelection(previous: readonly string[], next: string[]): string[] {
  const hadAll = isAllBranches(previous);
  const hasAll = isAllBranches(next);
  if (hasAll && !hadAll) return [ALL_BRANCHES];
  if (hasAll && next.length > 1) return next.filter((uId) => uId !== ALL_BRANCHES);
  return next;
}

/** The branch UIds of the request; empty stands for every branch. */
export function toRequestedBranchUIds(selection: readonly string[]): string[] {
  return isAllBranches(selection) ? [] : [...selection];
}
